import React, { use, useState, useEffect } from 'react';
import DossierService from '../../services/DossierService';
import { Box } from '@mui/material';
import CollapseSectionComponent from './CollapseSectionComponent';
import ViewSectionComponent from './ViewSectionComponent';


const SectionComponent = ({dossier}) => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(false);
    const doService = new DossierService();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await doService.allDossierSections(dossier);
                setSections(response);
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    return (
        <>
            <Box>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <ul>
                        {sections.map((section) => (
                            <ViewSectionComponent key={section.id} section={section} />
                        ))}
                    </ul>
                )}
            </Box>
        </>
    );
};
export default SectionComponent;